(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const bindHoverBehavior = () => {
    const menus = document.querySelectorAll('details.mega-menu');
    if (!menus.length) return;

    menus.forEach((menu) => {
      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) return;
        clearTimeout(closeTimer);
        menus.forEach((other) => {
          if (other !== menu) other.removeAttribute('open');
        });
        menu.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', () => {
        if (!desktopQuery.matches) return;
        closeTimer = setTimeout(() => menu.removeAttribute('open'), 100);
      });

      const summary = menu.querySelector('summary[data-menu-link]');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;

        const url = summary.dataset.menuLink;
        if (!url || url === '#') return;

        event.preventDefault();
        window.location.href = url;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHoverBehavior);
  } else {
    bindHoverBehavior();
  }
})();
